import style from './style.css';
import { useState, useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import {
  buyWithInstacredLandingRoute,
  offersInstacred,
  bicRevampCategoryViewAllPage,
  loginRoute,
  transactionHistoryRoute,
} from '../../../../../alias/homeRoutes';

import { tracker, UserActionType } from '../../../../../tracking';
import { connect } from 'react-redux';
import { isNavMenuRoute } from '../../../../../utils/navBar';
import { generateUrlWithParams } from '../../../../../utils/routeHandler';
import { isMobile } from '../../../../../utils/helper';

function BottomNav({ routeDetails, pageKey, campaignId }) {
  const [activeTab, setActiveTab] = useState('buy');

  useEffect(() => {
    const navPath = isNavMenuRoute();

    if (navPath) {
      setActiveTab(navPath);
    }
  }, [routeDetails]);

  const changeTab = (selectedTab) => {
    setActiveTab(selectedTab);
    tracker.trackUserInteraction(
      UserActionType.CLICK,
      `bic_bottom_navbar_${selectedTab.split('/')[1]}`,
      pageKey,
      {
        campaign_id: campaignId,
      },
    );

    switch (selectedTab) {
      case buyWithInstacredLandingRoute.path:
        route(
          generateUrlWithParams(buyWithInstacredLandingRoute.path, {
            utm_campaign: campaignId,
          }),
        );
        return;

      case offersInstacred.path:
        route(
          generateUrlWithParams(offersInstacred.path, {
            utm_campaign: campaignId,
          }),
        );
        return;

      case bicRevampCategoryViewAllPage.path:
        route(
          generateUrlWithParams(bicRevampCategoryViewAllPage.path, {
            utm_campaign: campaignId,
          }),
        );
        return;

      case transactionHistoryRoute.path:
        route(
          generateUrlWithParams(transactionHistoryRoute.path, {
            utm_campaign: campaignId,
          }),
        );
        return;

      case loginRoute.path:
        route(
          generateUrlWithParams(loginRoute.path, { utm_campaign: campaignId }),
        );
        return;
    }
  };

  return (
    <div
      className={`${
        isMobile
          ? style.bottomNavContainerVisible
          : style.bottomNavContainerHidden
      }`}>
      <div className={`${style.tabWrapper}`}>
        <div
          onClick={() => changeTab(buyWithInstacredLandingRoute.path)}
          className={`${style.tab} ${
            activeTab === buyWithInstacredLandingRoute.path
              ? style.activeTab
              : ''
          }`}>
          <div>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'>
              <path
                d='M3 24C2.175 24 1.4685 23.7312 0.880502 23.1936C0.292502 22.656 -0.000997453 22.0105 2.54669e-06 21.2571V8.91428C2.54669e-06 8.48 0.106502 8.06857 0.319502 7.68C0.532502 7.29143 0.826003 6.97143 1.2 6.72L10.2 0.548571C10.475 0.365714 10.7625 0.228571 11.0625 0.137143C11.3625 0.0457141 11.675 0 12 0C12.325 0 12.6375 0.0457141 12.9375 0.137143C13.2375 0.228571 13.525 0.365714 13.8 0.548571L22.8 6.72C23.175 6.97143 23.469 7.29143 23.682 7.68C23.895 8.06857 24.001 8.48 24 8.91428V21.2571C24 22.0114 23.706 22.6574 23.118 23.195C22.53 23.7326 21.824 24.0009 21 24H15V14.4H9V24H3Z'
                fill='#A8A3A3'
              />
              <rect x='8' y='8' width='8' height='4' rx='1' fill='white' />
            </svg>
          </div>
          <div
            id='cardlessEmi-tab'
            className={`${
              activeTab === buyWithInstacredLandingRoute.path
                ? style.highlightText
                : 'text60 text-center bold-500'
            }`}>
            Home
          </div>
        </div>
        <div
          onClick={() => changeTab(bicRevampCategoryViewAllPage.path)}
          className={`${style.tab}  ${
            activeTab === bicRevampCategoryViewAllPage.path
              ? style.activeTab
              : ''
          }`}>
          <div>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'>
              <path
                d='M1.33333 10.6667H9.33333C9.68696 10.6667 10.0261 10.5262 10.2761 10.2761C10.5262 10.0261 10.6667 9.68696 10.6667 9.33333V1.33333C10.6667 0.979711 10.5262 0.640573 10.2761 0.390524C10.0261 0.140476 9.68696 0 9.33333 0H1.33333C0.979711 0 0.640573 0.140476 0.390524 0.390524C0.140476 0.640573 0 0.979711 0 1.33333V9.33333C0 9.68696 0.140476 10.0261 0.390524 10.2761C0.640573 10.5262 0.979711 10.6667 1.33333 10.6667ZM14.6667 10.6667H22.6667C23.0203 10.6667 23.3594 10.5262 23.6095 10.2761C23.8595 10.0261 24 9.68696 24 9.33333V5.33333V1.33333C24 0.979711 23.8595 0.640573 23.6095 0.390524C23.3594 0.140476 23.0203 0 22.6667 0H14.6667C14.313 0 13.9739 0.140476 13.7239 0.390524C13.4738 0.640573 13.3333 0.979711 13.3333 1.33333V9.33333C13.3333 9.68696 13.4738 10.0261 13.7239 10.2761C13.9739 10.5262 14.313 10.6667 14.6667 10.6667ZM1.33333 24H9.33333C9.68696 24 10.0261 23.8595 10.2761 23.6095C10.5262 23.3594 10.6667 23.0203 10.6667 22.6667V14.6667C10.6667 14.313 10.5262 13.9739 10.2761 13.7239C10.0261 13.4738 9.68696 13.3333 9.33333 13.3333H1.33333C0.979711 13.3333 0.640573 13.4738 0.390524 13.7239C0.140476 13.9739 0 14.313 0 14.6667V22.6667C0 23.0203 0.140476 23.3594 0.390524 23.6095C0.640573 23.8595 0.979711 24 1.33333 24ZM18.6667 24C21.608 24 24 21.608 24 18.6667C24 15.7253 21.608 13.3333 18.6667 13.3333C15.7253 13.3333 13.3333 15.7253 13.3333 18.6667C13.3333 21.608 15.7253 24 18.6667 24Z'
                fill='#A8A3A3'
              />
              <path
                d='M16.5 4.5C16.5 3.94772 16.9477 3.5 17.5 3.5H19.5C20.0523 3.5 20.5 3.94772 20.5 4.5V6.5C20.5 7.05228 20.0523 7.5 19.5 7.5H17.5C16.9477 7.5 16.5 7.05228 16.5 6.5V4.5Z'
                fill='white'
              />
            </svg>
          </div>
          <div
            className={`${
              activeTab === bicRevampCategoryViewAllPage.path
                ? style.highlightText
                : 'text60 bold-500'
            }`}>
            Category
          </div>
        </div>
        <div
          onClick={() => changeTab(transactionHistoryRoute.path)}
          className={`${style.tab}  ${
            activeTab === transactionHistoryRoute.path ? style.activeTab : ''
          }`}>
          <div>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'>
              <path
                d='M22 0H2C1.46957 0 0.960859 0.210714 0.585787 0.585787C0.210714 0.960859 0 1.46957 0 2V22C0 22.5304 0.210714 23.0391 0.585787 23.4142C0.960859 23.7893 1.46957 24 2 24H22C22.5304 24 23.0391 23.7893 23.4142 23.4142C23.7893 23.0391 24 22.5304 24 22V2C24 1.46957 23.7893 0.960859 23.4142 0.585787C23.0391 0.210714 22.5304 0 22 0Z'
                fill='#A8A3A3'
              />
              <rect x='3' y='4' width='18' height='3' rx='1.5' fill='white' />
              <rect x='3' y='10' width='14' height='3' rx='1.5' fill='white' />
              <rect x='3' y='16' width='12' height='3' rx='1.5' fill='white' />
            </svg>
          </div>
          <div
            className={`${
              activeTab === transactionHistoryRoute.path
                ? style.highlightText
                : 'text60 bold-500'
            }`}>
            Dashboard
          </div>
        </div>
        <div
          onClick={() => changeTab(loginRoute.path)}
          className={`${style.tab}  ${
            activeTab === loginRoute.path ? style.activeTab : ''
          }`}>
          <div>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'>
              <path
                d='M21.3333 0H2.66667C1.2 0 0 1.2 0 2.66667V21.3333C0 22.8 1.2 24 2.66667 24H21.3333C22.8 24 24 22.8 24 21.3333V2.66667C24 1.2 22.8 0 21.3333 0ZM12 4C14.5733 4 16.6667 6.09333 16.6667 8.66667C16.6667 11.24 14.5733 13.3333 12 13.3333C9.42667 13.3333 7.33333 11.24 7.33333 8.66667C7.33333 6.09333 9.42667 4 12 4ZM21.3333 21.3333H2.66667V21.0267C2.66667 20.2 3.04 19.4267 3.68 18.92C5.96 17.0933 8.85333 16 12 16C15.1467 16 18.04 17.0933 20.32 18.92C20.96 19.4267 21.3333 20.2133 21.3333 21.0267V21.3333Z'
                fill='#A8A3A3'
              />
            </svg>
          </div>
          <div
            className={`${
              activeTab === loginRoute.path
                ? style.highlightText
                : 'text60 bold-500 '
            }`}>
            My Account
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ config, buyWithInstacred }) => {
  const { pageKey, routeDetails } = config;
  const { home } = buyWithInstacred;
  const { campaignId } = home;

  return {
    pageKey,
    campaignId,
    routeDetails,
  };
};
export default connect(mapStateToProps)(BottomNav);



// WEBPACK FOOTER //
// ./components/partial/container/bicRevampContainer/bottomNav/index.js